import Crud from '../components/SubCategoryProduct/Crud'
import Edit from '../components/SubCategoryProduct/Edit'

let routes = {
    path: '/subCategoryProduct',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
        {
            path: '/subCategoryProduct',
            component: Crud
        },
        {
            path: '/subCategoryProduct/edit/:id',
            component: Edit
        },
    ]
};


export default routes


// WEBPACK FOOTER //
// ./src/router/subCategoryProduct.js